// One on/off setting row in the Billing Review drill-down (slider + description + pending tag).
// Used for every staged boolean setting so they all look and gate the same way. The description
// lives in a "?" tooltip beside the label (like the Billing app), not as a paragraph under it.

import React from 'react';
import PendingTag from './PendingTag';
import HelpTip from './HelpTip';

export default function ConfigToggle({
  label, description, checked, disabled, saving, pending, onWithdraw, onChange,
}) {
  return (
    <div className="nc-item">
      <div className="detail-row tech-fee-toggle-row">
        <label
          className={`tech-fee-toggle ${saving ? 'saving' : ''} ${disabled ? 'disabled' : ''}`}
          onClick={e => e.stopPropagation()}
        >
          <input
            type="checkbox"
            checked={!!checked}
            disabled={disabled || saving}
            onChange={e => onChange(e.target.checked)}
          />
          <span className="tech-fee-slider" />
          <span className="tech-fee-label">
            {label}
            {/* Inside the title span so the "?" stays on the title's line, however narrow the card. */}
            {description && <HelpTip text={description} />}
            {saving && <em className="tech-fee-saving"> saving…</em>}
          </span>
        </label>
        <PendingTag change={pending} onWithdraw={onWithdraw} />
      </div>
    </div>
  );
}
